import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
// 路径匹配引擎: https://www.npmjs.com/package/path-to-regexp
const pathToRegexp = require('path-to-regexp');
// 使用异步component
// import com from './com.vue' 为同步
// const com = () => import('./com.vue') 为异步
export function createRouter () {
    const router = new Router({
        mode: 'history',
        scrollBehavior: (to, from, savedPosition) => {
            savedPosition = from.meta.savedPosition;
            if (savedPosition) {
                // savedPosition is only available for popstate navigations.
                return savedPosition;
            } else {
                const position = {};
                // new navigation.
                // scroll to anchor by returning the selector
                // check if any matched route config has meta that requires scrolling to top
                if (to.matched.some(m => m.meta.scrollToTop)) {
                    // cords will be used if no selector is provided,
                    // or if the selector didn't match any element.
                    position.x = 0;
                    position.y = 0;
                }
                // if the returned position is falsy or an empty object,
                // will retain current scroll position.
                return position;
            }
        },
        // 为了兼容老路由 news文章 matchDetail比赛详情 home首页 match比赛列表
        // http://wiki.dongqiudi.net/pages/viewpage.action?pageId=3437685
        routes: [
            {
                path: '/',
redirect: to => {
                    return {
                        name: 'news'
                    };
                }
            },
            {
                path: '/home',
redirect: to => {
                    if (to.query.subtitle) {
                        return `news/${to.query.subtitle}`;
                    } else {
                        return { name: 'news' };
                    }
                }
            },
            {
                path: '/match',
redirect: to => {
                    if (to.query.subtitle) {
                        return `/matchs/${to.query.subtitle}`;
                    } else {
                        return '/matchs';
                    }
                }
            },
            {
                path: '/news',
                redirect: to => {
                    if (to.query.id) {
                        if (to.query.subtitle) {
                            return `/news/${to.query.subtitle}/${to.query.id}`;
                        } else {
                            return `/news/Headline/${to.query.id}`;
                        }
                    } else {
                        return { name: 'news' };
                    }
                }
            },
            {
                path: '/matchDetail',
                redirect: to => {
                    if (to.query.subtitle && to.query.id) {
                        return `/match/${to.query.subtitle}/${to.query.id}`;
                    } else {
                        return 'matchs';
                    }
                }
            },
            {
                path: '/matchPlayerScore/:id',
                component: () => import('../pages/matchPlayerScore.vue'),
                meta: {
                  keepAlive: false
                }
            },
            {
                path: '/news/:subtitle(^[A-Za-z0-9]+$)?/:title?/:id?',
                name: 'news',
                component: () => import('../pages/AppHome.vue'),
                meta: {
                    keepAlive: true,
                    scrollToTop: false
                }
            },
            {
                path: '/video/:subtitle?',
                component: () => import('../pages/AppVideo.vue'),
                meta: { keepAlive: true, scrollToTop: false }
            },
            {
                path: '/match/:subtitle/:title?/:id',
                component: () => import('../pages/AppMatchDetail.vue'),
                meta: {
                    keepAlive: false
                }
            },
            {
                path: '/stats/:subtitle?',
                component: () => import('../pages/AppStats.vue'),
                meta: {
                    keepAlive: false
                }
            },
            {
                path: '/matchs/:subtitle([A-Za-z0-9]+)?',
                component: () => import('../pages/AppMatch.vue'),
                meta: {
                    keepAlive: false
                }
            },
            {
                path: '/news/:subtitle/:title?/:id([0-9]+)',
                // alias: '/video/:subtitle/:id/:title',
                component: () => import('../pages/AppNews.vue'),
                meta: {
                    keepAlive: false,
                    scrollToTop: true
                }
            },
            {
                path: '/matchOdds',
                component: () => import('../pages/AppMatchOdds.vue'),
                meta: {
                    keepAlive: false
                }
            },
            { path: '/download', component: () => import('../pages/AppDownload.vue') },
            { path: '/downloadNew', component: () => import('../pages/AppDownloadNew.vue') },
            { path: '/downloadApp', component: () => import('../pages/downloadApp.vue') },
            { path: '/downloadCoin', component: () => import('../pages/AppDownloadCoin.vue') },
            { path: '/live', component: () => import('../pages/AppLiveList.vue') },
            { path: '/answerShare', component: () => import('../pages/AppAnswerShare.vue') },
            { path: '/wakeUp', component: () => import('../pages/AppWakeUp.vue') },
            {
                path: '/tweet',
                component: () => import('../pages/AppTweet.vue'),
                meta: {
                    keepAlive: false,
                    scrollToTop: true
                }
            },
            {
                path: '*',
                name: '404',
                component: () => import('../pages/downloadApp.vue')
            }
        ]
    });
    router.beforeEach((to, from, next) => {
        if (typeof ga === 'function') {
            ga('send', 'pageview', to.path);
        }
        next();
    });
    return router;
}



// WEBPACK FOOTER //
// ./src/router/index.js